export const passwordFormat = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/

export const validatePassword = (password: string) =>
  passwordFormat.test(password)
